import React, {useEffect, useState, useRef} from 'react';

import * as S from './OfferCarouselUI.styles';
import useCarousel from '../../../../../shared/hooks/useCarousel';
import {defaultTheme} from '@stencil/build-theme';

import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import HappyAngleLeftIcon from '@stencil/icons/src/HappyAngleLeftIcon/HappyAngleLeftIcon';

// dataFromState and data in useState set via fetchData are expected to be same
// ! can be handled better, revisit
const OfferCarouselUI = ({
  dataFromState,
  bannerData,
  actionHandler,
  eventMiddlewareForHotelsDwebFE,
  homePageClicksGAHandler,
  sliderClicksGAHandler,
}) => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
  } = useCarousel(dataFromState, 2);
  return (
    <S.HomeCaroMainWrap>
      <HomeBannerComponent
        bannerData={bannerData}
        eventMiddlewareForHotelsDwebFE={eventMiddlewareForHotelsDwebFE}
        homePageClicksGAHandler={homePageClicksGAHandler}
      />
      <S.HomeCaroSliderInnerWrap>
        {dataList.map(
          item =>
            (item.sub_heading && item.img_url && (
              <li
                key={'offerCaro' + item.sub_heading}
                onClick={() => {
                  if (item.url) {
                    actionHandler(item.url);
                    homePageClicksGAHandler();
                  }
                }}
              >
                <S.SliderImg src={item.img_url} alt={item.sub_heading} />
                <S.SliderInfoWrap>
                  <S.SliderHeadInfoText>{item.sub_heading}</S.SliderHeadInfoText>
                  <S.SliderInfoSubText>Valid till: {item?.validity_text}</S.SliderInfoSubText>
                </S.SliderInfoWrap>
              </li>
            )) ||
            null,
        )}
        {(isRightCursorActive && (
          <S.SliderArrowRight
            onClick={eventMiddlewareForHotelsDwebFE({
              onClick: () => {
                increment();
                sliderClicksGAHandler(`+${rightCursor}`);
              },
              eventObj: {
                eventAction: 'OfferCarouselRightArrowClick',
              },
            })}
            data-testid="offerCarouselRightArrowBtn"
          >
            <HappyAngleRightIcon fill={defaultTheme.colors.goBrandBlue.base} />
          </S.SliderArrowRight>
        )) ||
          null}
        {(isLeftCursorActive && (
          <S.SliderArrowLeft
            onClick={eventMiddlewareForHotelsDwebFE({
              onClick: () => {
                decrement();
                sliderClicksGAHandler(`-${leftCursor}`);
              },
              eventObj: {
                eventAction: 'OfferCarouselLeftArrowClick',
              },
            })}
            data-testid="offerCarouselLeftArrowBtn"
          >
            <HappyAngleLeftIcon fill={defaultTheme.colors.goBrandBlue.base} />
          </S.SliderArrowLeft>
        )) ||
          null}
      </S.HomeCaroSliderInnerWrap>
    </S.HomeCaroMainWrap>
  );
};

const HomeBannerComponent = ({
  bannerData,
  eventMiddlewareForHotelsDwebFE,
  homePageClicksGAHandler,
}) => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
    reset,
  } = useCarousel(bannerData, 1, true);
  var timerId;
  const [activeBannerIndex, setActiveBannerIndex] = useState(0);
  const activeIndexForSetTimeout = useRef(activeBannerIndex);

  const incrementSlider = () => {
    let index = activeIndexForSetTimeout.current + 1;
    if (activeIndexForSetTimeout.current === bannerData.length - 1) index = 0;
    setActiveBannerIndex(index);
    clearInterval(timerId);
    increment();
  };

  const decrementSlider = () => {
    let index = activeIndexForSetTimeout.current - 1;
    if (activeIndexForSetTimeout.current == 0) index = bannerData.length - 1;
    setActiveBannerIndex(index);
    clearInterval(timerId);
    decrement();
  };

  useEffect(() => {
    activeIndexForSetTimeout.current = activeBannerIndex;
  }, [activeBannerIndex]);

  useEffect(() => {
    const bannerDataLength = bannerData.length;
    if (bannerDataLength && !timerId) {
      timerId = setInterval(() => {
        if (bannerDataLength) {
          if (activeIndexForSetTimeout.current < bannerDataLength - 1) {
            setActiveBannerIndex(activeIndexForSetTimeout.current + 1);
            increment();
          } else {
            setActiveBannerIndex(0);
            reset();
          }
        }
      }, 3000);
    }
    return () => clearInterval(timerId);
  }, [dataList]);

  const onClickHandlerForBanner = item => {
    homePageClicksGAHandler('bannerClicked', item?.ctaUrl);
    if (item && item?.ctaUrl) window.open(item?.ctaUrl, '_blank');
  };

  return (
    (bannerData && bannerData.length > 0 && (
      <S.HomeCaroSliderInnerWrap>
        <S.HomeCaroMainImageWrap>
          <S.HomeCaroBigImg
            src={bannerData[activeBannerIndex]?.image}
            onClick={eventMiddlewareForHotelsDwebFE({
              onClick: () => {
                onClickHandlerForBanner(bannerData[activeBannerIndex]);
              },
              eventObj: {
                eventAction: 'OfferCarouselBannerClick',
              },
            })}
            data-testid="offerCarouselMainImageBanner"
          />
        </S.HomeCaroMainImageWrap>
        {(isRightCursorActive && (
          <S.SliderArrowRight
            onClick={eventMiddlewareForHotelsDwebFE({
              onClick: () => {
                incrementSlider();
                onClickHandlerForBanner(`+${rightCursor}`);
              },
              eventObj: {
                eventAction: 'OfferCarouselRightArrowClick',
              },
            })}
            data-testid="offerCarouselRightArrowBtn+!"
          >
            <HappyAngleRightIcon fill={defaultTheme.colors.goBrandBlue.base} />
          </S.SliderArrowRight>
        )) ||
          null}
        {(isLeftCursorActive && (
          <S.SliderArrowLeft
            onClick={eventMiddlewareForHotelsDwebFE({
              onClick: () => {
                decrementSlider();
                onClickHandlerForBanner(`-${leftCursor}`);
              },
              eventObj: {
                eventAction: 'OfferCarouselLeftArrowClick',
              },
            })}
            data-testid="offerCarouselLeftArrowBtn_!"
          >
            <HappyAngleLeftIcon fill={defaultTheme.colors.goBrandBlue.base} />
          </S.SliderArrowLeft>
        )) ||
          null}
      </S.HomeCaroSliderInnerWrap>
    )) ||
    null
  );
};

export default React.memo(OfferCarouselUI);
